import { gql } from '@apollo/client';
import { Kind, parse } from 'graphql';
import { Logger } from '../lib/logger';
export const mutate = (doc, input = {}, options = {}) => ({
    mutation: gql(doc),
    variables: { input },
    ...options
});
export const query = (doc, input = {}) => ({
    query: gql(doc),
    variables: input
});
export const action = (name) => ({ data }) => data[name];
export const changeOnly = (existing, intention) => {
    const change = {};
    Object.keys(intention).forEach((key) => {
        if (existing[key] !== intention[key])
            change[key] = intention[key];
    });
    return change;
};
export const parseGraphQLError = (e) => {
    const { graphQLErrors } = e;
    Logger.log('parseError', e);
    return graphQLErrors && graphQLErrors.length > 0 ? graphQLErrors[0].message : '';
};
export const getAction = (doc) => {
    const document = parse(doc);
    const operation = document.definitions.find((def) => def.kind === Kind.OPERATION_DEFINITION);
    return operation?.selectionSet.selections[0].name.value;
};
